// src/components/tutor/tutorFirestore.js
import { db } from "../../firebaseConfig"; // Adjust path if needed (e.g. ../../firebaseConfig)
import { doc, getDoc, updateDoc } from "firebase/firestore";

/**
 * Reads the tutor's /users/{uid} document.
 */
export async function fetchMyTutorDoc(uid) {
  if (!uid) return null;
  const ref = doc(db, "users", uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

/**
 * Updates allowed fields only on /users/{uid}.
 * We intentionally block edits to sensitive fields like rates.
 */
export async function updateMyTutorDoc(uid, patch) {
  const blocked = new Set(["name", "status", "teachingRate", "adminRate", "role", "email"]); 
  const safe = {};
  Object.keys(patch || {}).forEach((k) => {
    if (!blocked.has(k)) safe[k] = patch[k];
  });

  const ref = doc(db, "users", uid);
  await updateDoc(ref, safe);
}